import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { getFiatWallet } from '../fiatWalletEndpoints'
import { fiatWalletKeys } from '../fiatWalletQueryKeys'
import { toFiatWalletDisplay } from '../fiatWalletParser'

export function useFiatWalletQuery() {
  const query = useQuery({
    queryKey: fiatWalletKeys.fiat(),
    queryFn: getFiatWallet,
  })

  const display = computed(() => (query.data.value ? toFiatWalletDisplay(query.data.value) : null))

  return { ...query, display }
}
